<div class="view-container">
    <div class="view">
        <img src="/assets/images/mensajeCV19.jpg">
    </div>
</div>